var _rect, _rect2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMiniPark03(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 259,
    height: 253,
    viewBox: "0 0 259 253",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.0910645,
    y: 0.89624,
    width: 258,
    height: 252,
    fill: "#D38D8D"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3224_13918",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 259,
    height: 253
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.0910645,
    y: 0.89624,
    width: 258,
    height: 252,
    fill: "#B2B2B2"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3224_13918)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M224.767 142.405V200.284C224.767 202.324 228.338 203.977 232.738 203.977C237.139 203.977 240.71 202.324 240.71 200.284V142.405H224.767Z",
    fill: "#6F7976"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.767 142.405H240.71V185.079L224.767 175.793V142.405Z",
    fill: "#0B231C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.625 158.945L251.035 65.6615C249.245 57.0308 241.596 50.8401 232.73 50.8401C223.856 50.8401 216.214 57.0308 214.425 65.6615L192.834 158.945C192.658 159.382 192.555 159.834 192.555 160.285C192.555 166.673 210.538 171.851 232.73 171.851C254.922 171.851 272.904 166.673 272.904 160.285C272.904 159.834 272.801 159.382 272.625 158.945Z",
    fill: "#448974"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.425 65.6615C215.658 59.7144 219.67 54.9258 224.949 52.5229C229.214 50.5812 233.453 54.0952 234.47 58.6705L257.953 164.326C256.673 166.138 249.836 170.182 232.73 171.851C210.538 171.851 192.555 166.673 192.555 160.285C192.555 159.834 192.658 159.382 192.834 158.945L214.425 65.6615Z",
    fill: "#112922"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.724 142.405V200.284C135.724 202.324 139.295 203.977 143.695 203.977C148.096 203.977 151.667 202.324 151.667 200.284V142.405H135.724Z",
    fill: "#6F7976"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.724 142.405H151.667V188L135.724 179.486V142.405Z",
    fill: "#0B231C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.584 158.945L161.994 65.6615C160.204 57.0308 152.555 50.8401 143.689 50.8401C134.815 50.8401 127.173 57.0308 125.384 65.6615L103.8 158.945C103.624 159.382 103.522 159.834 103.522 160.285C103.522 166.673 121.504 171.851 143.696 171.851C165.888 171.851 183.87 166.673 183.87 160.285C183.87 159.834 183.768 159.382 183.592 158.945H183.584Z",
    fill: "#112922"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.967 155.32V213.2C199.967 215.239 203.538 216.892 207.938 216.892C212.339 216.892 215.91 215.239 215.91 213.2V155.32H199.967Z",
    fill: "#6F7976"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.967 155.32H215.91V184.26L199.967 173.363V155.32Z",
    fill: "#0B231C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.834 154.692L226.243 50.4398C224.454 41.8092 216.804 35.6184 207.938 35.6184C199.064 35.6184 191.422 41.8092 189.633 50.4398L168.042 154.692C167.866 155.129 167.764 155.581 167.764 156.032C167.764 162.42 185.746 167.598 207.938 167.598C230.13 167.598 248.112 162.42 248.112 156.032C248.112 155.581 248.01 155.129 247.834 154.692Z",
    fill: "#83CCB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.759 242.896V223.099H189.525C194.023 223.099 196.607 225.875 196.607 229.771C196.607 233.722 193.982 236.443 189.415 236.443H185.861V242.896H181.759ZM185.861 233.135H188.759C191.193 233.135 192.382 231.767 192.368 229.771C192.382 227.802 191.193 226.476 188.759 226.463H185.861V233.135ZM200.572 243.142C199.286 243.142 198.247 242.117 198.275 240.845C198.247 239.588 199.286 238.562 200.572 238.576C201.788 238.562 202.841 239.588 202.841 240.845C202.841 242.117 201.788 243.142 200.572 243.142ZM206.177 242.896V223.099H213.943C218.441 223.099 221.025 225.875 221.025 229.771C221.025 233.722 218.4 236.443 213.833 236.443H210.279V242.896H206.177ZM210.279 233.135H213.177C215.611 233.135 216.8 231.767 216.786 229.771C216.8 227.802 215.611 226.476 213.177 226.463H210.279V233.135ZM227.587 223.099V242.896H223.54V223.099H227.587ZM237.458 243.197C232.906 243.183 230.116 240.244 230.13 235.541C230.116 230.961 232.947 227.857 237.294 227.857C241.191 227.857 244.267 230.318 244.267 235.377V236.525H234.122C234.122 238.767 235.448 240.148 237.54 240.162C238.921 240.148 239.906 239.547 240.302 238.658H244.157C243.583 241.406 241.122 243.183 237.458 243.197ZM234.122 233.982H240.439C240.425 232.177 239.181 230.879 237.376 230.892C235.517 230.879 234.204 232.273 234.122 233.982Z",
    fill: "black"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiniPark03);
export default __webpack_public_path__ + "static/media/mini_park_03.ea12190200fcdc4a2b3eb4181e54b9e0.svg";
export { ForwardRef as ReactComponent };